import styled from "styled-components";
import { darken } from "polished";

export const Container = styled.div`
  display: flex;
  align-items: center; 

  ul {
    li {
      text-align: center;
      
      button, a {
        border: none;
        background: none;
        color: #fff;
        cursor: pointer;
        text-transform: uppercase;
        padding: 15px;
        display: block;
        width: 100%;
      }

      :hover {
        background-color: ${ darken(0.06, "#0B4682") };
      }

      :first-child {
        border-bottom: 1px solid #FFF;
      }
    }
  }
  
  @media (max-width: 767px) {
    justify-content: center;
    flex-direction: column;
    background: #0B4682;
    text-align: center;
    position: absolute;
    top: 64px;
    right: 30px;
    transition: transform 0.4s ease-in-out;
    z-index: 1;
    
    li {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;

export const MenuContent = styled.div`
  display: flex;
  align-items: center; 

  @media (max-width: 767px) {
    display: none;
  }
`;

export const MenuMobile = styled.ul`
  display: ${({ open }) => open ? 'block' : 'none'};
`;

export const UserData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: right;
  margin-right: 10px;
`;

export const UserName = styled.h3`
  font-size: 1.375rem;
  line-height: 1.625rem;
  font-weight: bold;
`;

export const UserCpf = styled.p`
  font-size: 1rem;
  line-height: 1.3rem;
`;

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-itens: center;
`;

export const UserAvatar = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid #fff;
`;

export const MenuBtn = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  background: none;
  color: #fff;
  border: none;
  margin-left: 10px;
  cursor: pointer;
  padding-right: 10px;
  &&:hover {
    .dropdown {
      display: block;
    }
  }
  &&:focus {
    outline: none;
  }
`;

export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  top: 45px;
  background-color: #0b4682;
  min-width: 150px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;